<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    vSelect
  }
}
</script>

<template>
  <v-select />
</template>